module.exports = __webpack_public_path__ + "static/media/car-history.dfca012b.jpg";